// @vendors
import { useEffect, useContext } from "react"
import { Tooltip, Progress } from 'antd'
import cx from 'classnames'
import Context from '../../context/appContext';
import usePrismicByUID from "hooks/usePrismicByUID";

// @utils
import { getKeys, getPercentage } from 'utils/utils'

// @styles
import './styles.scss'

export default function Subheader() {
    const { info } = usePrismicByUID('flujo_cotizacion_v2');
    const { formStatus: { steps, currentStep, currentQuestion }, folio, tokenInfo,
        dataForm: { formResponses }, returnButton, showHomePage, setDisabledButtonContinue, progressStep,
        setFormStatus, setProgressStep, setIsSendForm } = useContext(Context);

    useEffect(() => {
        document.getElementById('top')?.scrollIntoView({ behavior: 'smooth' });
        if (progressStep.length > 0) {
            const index = getIndex();
            let newProgressStep = JSON.parse(JSON.stringify(progressStep));
            newProgressStep[index].current = currentQuestion;
            setProgressStep(newProgressStep);
        }
    }, [currentQuestion]);

    useEffect(() => {
        document.getElementById('top')?.scrollIntoView({ behavior: 'smooth' });
        if (progressStep.length > 0) {
            const index = getIndex();
            let newProgressStep = JSON.parse(JSON.stringify(progressStep));
            newProgressStep[index].active = true;
            setProgressStep(newProgressStep);
        }
    }, [currentStep]);

    useEffect(() => {
        steps && steps.forEach(step => {

            const newStep = {
                key_step: step.key_step,
                name: step.name,
                current: 0,
                quantity: step.questions.length - 1,
                active: progressStep.length === 0 ? true : false
            }

            const index = progressStep.findIndex(value => value.key_step === step.key_step);
            if (index === -1) {
                progressStep.push(newStep);
            }
        });

    }, [steps]);

    const resetFields = () => {
        const stp = steps[currentStep] && steps[currentStep].questions[currentQuestion];
        if (stp && stp.newItems && stp.newItems.length > 0) {
            const check = stp.newItems.findIndex((x) =>
                x.key.includes('datosContratanteIgualAsegurado'));
            if (check !== -1) {
                stp.newItems.forEach((stpi, index) => {
                    if (stpi && stpi.key !== 'tipoDePersonaContratante' && stpi.key !== 'datosContratanteIgualAsegurado') {
                        stp.newItems[index].value = '';
                    }
                });
            }
        }
    }

    const goToBack = () => {
        setDisabledButtonContinue(false);
        resetFields();
        if (currentStep === 0 && currentQuestion === 0) {
            if (tokenInfo && tokenInfo.usuarioId) {
                window.location.href = process.env.REACT_APP_URL_REDIRECT;
            } else {
                window.location.reload()
            }
        } else {
            let currentStepIndex = currentStep === 0 || currentQuestion > 0 ? currentStep : currentStep - 1;
            const question = steps[currentStepIndex]?.questions[currentQuestion];
            const conditionalField = question && question.newItems.length === 1 &&
                question.newItems.find(x => x.conditional);
            if (conditionalField) {
                currentStepIndex = !validateConditional(conditionalField) ? currentStepIndex - 1 : currentStepIndex;
                progressStep[currentStep - 1].active = currentQuestion === 0 ? false : true;
            }
            const quantity = steps[currentStepIndex]?.questions.length;
            progressStep[currentStep].active = currentQuestion === 0 ? false : true;

            setFormStatus({
                steps,
                currentStep: currentStepIndex,
                currentQuestion: currentQuestion > 0 ? currentQuestion - 1 : quantity - 1,
                numberQuestionsStep: quantity,
                isGoToBack: true
            });
            setIsSendForm(true);
        }
    }

    const validateConditional = (field) => {
        const fieldValue = field && field.conditional ? formResponses.find(value => value.key === field.conditional.when) : {};
        return fieldValue && Object.keys(fieldValue).length > 0 && fieldValue.value ?
            (fieldValue.value).toString() === field.conditional.eq ? field.conditional.show : false : !(field && field.conditional);
    }

    const getIndex = () => {
        const key_step = steps[currentStep].key_step;
        const index = progressStep.findIndex(value => value.key_step === key_step);
        return index;
    }

    return showHomePage ? '' : (
        <div className='subheader-ppal'>
            <div className='container-xl'>
                {returnButton && (<div className='subheader-ppal__left'>
                    <div className='subheader-ppal__left-button' onClick={goToBack}>
                        <em className='fal fa-long-arrow-left' /> Volver
                    </div>
                </div>)}
                <div className='subheader-ppal__right'>
                    <div className='subheader-ppal__right-description'>
                        <p>{info && info.data && info.data.title}</p>
                        <span>{info && info.data && info.data.description}</span>
                    </div>
                    <div className='subheader-ppal__right-steps'>
                        <div className={
                            cx(
                                'steps-container',
                                { 'steps-container-finish': progressStep.length === currentStep }
                            )
                        }>
                            {progressStep.map((item, index) => (
                                <div
                                    className={
                                        cx(
                                            'steps-item',
                                            { 'steps-item-active': item.active }
                                        )
                                    }
                                    key={`step-${index}`}
                                >
                                    <Tooltip
                                        placement='top'
                                        title={item.name}
                                    >
                                        <div className='steps-item__dot' />
                                    </Tooltip>


                                    <Progress percent={getPercentage(item)} size="small" showInfo={false} />

                                </div>
                            ))}
                            <Tooltip
                                placement='top'
                                title={'Pasarela de pago'}
                            >
                                <div className='steps-item-last' />
                            </Tooltip>

                        </div>
                    </div>
                    {folio && (<div className='subheader-ppal__right-folio'>
                        Folio: {folio}
                    </div>)}
                </div>
            </div>
        </div>
    )
}